import React, { useState, useEffect } from 'react'
// import ReactBodymovin from 'react-bodymovin'
import animation from './leaf.json'
import BodyMovin from '../BodyMovin.js';
import './_animation.scss';


const LeafAniLeft = () => {
  const [isPlay, setPlay] = useState(false);

  const bodymovinOptions = {
    loop: false,
    autoplay: true,
    prerender: true,
    animationData: animation
  }

  useEffect(() => {
    const timer = setTimeout(() => { setPlay(true) }, 500);
    return () => clearTimeout(timer);
  }, []);

  // 1초 정도 위에
  return (
    <>
      {
        isPlay &&
        <div className="leaf left-leaf">
          <BodyMovin className="" options={bodymovinOptions} />
        </div>
      }
    </>
  )
}

export default LeafAniLeft;
